import { render, staticRenderFns } from "./MyAddon.vue?vue&type=template&id=077babaa&scoped=true&"
import script from "./MyAddon.vue?vue&type=script&lang=js&"
export * from "./MyAddon.vue?vue&type=script&lang=js&"
import style0 from "./MyAddon.vue?vue&type=style&index=0&id=077babaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077babaa",
  null
  
)

export default component.exports